import $http from '../../shared/http';

export const membership_manners = {
  namespaced: true,
  state: () => {
    return {
      membershipMannersForSelect: null,
      existingMembershipMannerNames: null,
      membershipMannerData: null,
    };
  },
  getters: {
    getMembershipMannersForSelect: (state) => state.membershipMannersForSelect,
    getExistingMembershipMannerNames: (state) => state.existingMembershipMannerNames,
    getMembershipMannerData: (state) => state.membershipMannerData,
  },
  mutations: {
    setMembershipMannersForSelect: (state, payload) => (state.membershipMannersForSelect = payload),
    setExistingMembershipMannerNames: (state, data) => {
      state.existingMembershipMannerNames = data;
    },
    setMembershipMannerData: (state, payload) => (state.membershipMannerData = payload),
  },
  actions: {
    async loadMembershipMannersForSelect({ commit, rootGetters }, { churchId, filter }) {
      const isLoggedInForSelfRegistration =
        rootGetters['membership_self_registrations/isLoggedInForSelfRegistration'];
      const selfRegistrationToken =
        rootGetters['membership_self_registrations/getSelfRegistrationToken'];

      if (!churchId) {
        throw new Error('Church ID not provided');
      }

      return $http('v2')
        .get(
          !isLoggedInForSelfRegistration
            ? `organisations/${churchId}/membership_manners/select`
            : `membership_self_registrations/membership_manners/select?token=${selfRegistrationToken}`,
          { canBeImpersonated: true, params: { ...filter } }
        )
        .then((response) => {
          commit('setMembershipMannersForSelect', response.data.data);
          return response;
        });
    },

    async getMembershipMannerNamesAction({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        commit('setExistingMembershipMannerNames', null);
        await $http()
          .get(`/organisations/${churchId}/membership-manners/check/names`, {
            canBeImpersonated: true,
          })
          .then((response) => {
            commit('setExistingMembershipMannerNames', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async LOAD_MEMBERSHIP_MANNER_DATA({ commit }, ID) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/membership-manners/${ID}`)
          .then(async (response) => {
            commit('setMembershipMannerData', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async CREATE_MEMBERSHIP_MANNER(ctx, { form }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/membership-manners`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async EDIT_MEMBERSHIP_MANNER(ctx, { form, ID }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(`/membership-manners/${ID}`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async DELETE_MEMBERSHIP_MANNER(ctx, { id }) {
      return $http()
        .delete(`/membership-manners/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
};
